export default __webpack_public_path__ + "static/media/Rabeea Wajeeha.80a07b5d.png";